// extracted by mini-css-extract-plugin
module.exports = {"statusContainer":"status_statusContainer__2TVNn","status":"status_status__ED8kj","balance":"status_balance__SX7Lx","value":"status_value__OFGXf"};